/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_marker__pin = /** @type {(inputs: {}) => string} */ () => {
	return `Kartennadel`
};

const en_poi_marker__pin = /** @type {(inputs: {}) => string} */ () => {
	return `Pin`
};

const es_poi_marker__pin = /** @type {(inputs: {}) => string} */ () => {
	return `Pin`
};

const fr_poi_marker__pin = /** @type {(inputs: {}) => string} */ () => {
	return `Pin`
};

const it_poi_marker__pin = /** @type {(inputs: {}) => string} */ () => {
	return `Pin`
};

const nl_poi_marker__pin = /** @type {(inputs: {}) => string} */ () => {
	return `Pin`
};

const pt_poi_marker__pin = /** @type {(inputs: {}) => string} */ () => {
	return `Pinho`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_marker__pin = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_marker__pin(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_marker__pin", locale)
	if (locale === "de") return de_poi_marker__pin(inputs)
	if (locale === "en") return en_poi_marker__pin(inputs)
	if (locale === "es") return es_poi_marker__pin(inputs)
	if (locale === "fr") return fr_poi_marker__pin(inputs)
	if (locale === "it") return it_poi_marker__pin(inputs)
	if (locale === "nl") return nl_poi_marker__pin(inputs)
	return pt_poi_marker__pin(inputs)
};